import ProcessIcon from './ProcessIcon.svg';
import AlertIcon from './AlertIcon.svg';
import NotFoundIcon from './NotFoundIcon.svg';
import ExpiredIcon from './ExpiredIcon.svg';

export default {
  ProcessIcon,
  AlertIcon,
  NotFoundIcon,
  ExpiredIcon,
};
